import { Controller } from 'stimulus';
import MitreTable from '../utils/mitre-table';

export default class SecuritiesFilter extends Controller {
  static targets = [
    'securities'
  ];

  connect() {
    const tableKey = this.element.closest('[data-table-key-value]').getAttribute('data-table-key-value');
    this._mitreTable = MitreTable.getByTableKey(tableKey);

    this._refreshUI();

    this._mitreTable.on('update_collection_keys_filter', () => this._refreshUI());
    this._mitreTable.on('reset_filters', () => this._refreshUI());
  }

  updateFilter(e) {
    e.preventDefault();

    this._mitreTable.emit('interaction', { type: MitreTable.InteractionType.FILTER_CHANGE });
    if (MitreTable.areInteractionsLocked()) return;

    let collectionKey = e.currentTarget.dataset.value;
    if (collectionKey) {
      this._mitreTable.setParam('collectionKey', collectionKey);
      this._refreshUI();

      this._mitreTable.emit('update_collection_filter');
      this._mitreTable.emit('update_filter_counter');
    }
  }

  _refreshUI() {
    const { collectionKey } = this._mitreTable.getParams();

    this.securitiesTargets.forEach((el) => {
      if(el.dataset['value'] === collectionKey) {
        el.classList.add('mp-page-filter-body-area-power-filters-filter__selected');
      } else {
        el.classList.remove('mp-page-filter-body-area-power-filters-filter__selected');
      }
    })
  }
};